import { useMemo, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NavigationRoutes from '../../../../Layouts/NavigationRoutes';
import JoinedSelectionButtons from '../../../Components/Form/Buttons/JoinedSelectionButtons/JoinedSelectionButtons';
import TextButton from '../../../Components/Form/Buttons/TextButton';
import ComponentHeader from '../../../Components/Headers/ComponentHeader';
import useLanguage from '../../../Services/Language/useLanguageHook';
import { EventDataTargetsEnum } from '../../../Services/Logging/DataLayerDefinitions';
import DairyRevenueProtection from './DairyRevenueProtection/DairyRevenueProtection';
import styles from './InsuranceQuoteEstimator.module.scss';
import LivestockRevenueProtection from './LivestockRevenueProtection/LivestockRevenueProtection';

const InsuranceQuoteEstimator: React.FC = () => {
    // Application hooks.
    const [translations] = useLanguage();
    const navigate = useNavigate();

    // Display hooks.
    const [displaySelection, setDisplaySelection] = useState('livestockRevenueProtection');

    const selectionGroupOptions = useMemo(
        () => [
            {
                label: translations.risk.insuranceQuoteEstimator.text.defaultRiskPremium,
                value: 'defaultRiskPremium',
            },
            {
                label: translations.risk.insuranceQuoteEstimator.text.livestockRevenueProtection,
                value: 'livestockRevenueProtection',
            },
        ],
        [],
    );

    return (
        <div className={styles.insurance_quote_estimator}>
            <div className={styles.liquidity_risk_section}>
                <ComponentHeader title={translations.risk.headers.insuranceQuote} />
            </div>
            <div className={styles.liquidity_risk_section}>
                <div className={styles.insurance_quote_estimator_selection_buttons}>
                    <JoinedSelectionButtons
                        name={EventDataTargetsEnum.InsuranceQuoteEstimatorJoinedSelectionButton}
                        options={selectionGroupOptions}
                        handleSelectionChange={(selectionValue) => setDisplaySelection(selectionValue)}
                        selection={displaySelection}
                        testId="MarginSelectionButtons"
                        track={{ eventCategory: 'InsuranceQuoteEstimator', eventAction: 'DisplaySelectionChanged', eventValue: displaySelection }}
                    />
                    <TextButton
                        title={translations.risk.insuranceQuoteEstimator.text.manageSubscriptions}
                        onClick={() => navigate(NavigationRoutes.EmailSubscriptions)}
                        track={{ eventCategory: 'InsuranceQuoteEstimator', eventAction: 'ManageEmailSubscriptionsClicked' }}
                    />
                </div>
            </div>
            {displaySelection === 'defaultRiskPremium' ? <DairyRevenueProtection /> : <LivestockRevenueProtection />}
        </div>
    );
};

export default InsuranceQuoteEstimator;
